import { render, staticRenderFns } from "./UserCountry.vue?vue&type=template&id=14015014"
import script from "./UserCountry.vue?vue&type=script&lang=js"
export * from "./UserCountry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports